import DOMPurify from 'dompurify'

export function escapeHtml (value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function normalizeLinkUrl (value) {
  if (!value && value !== 0) return null
  const raw = String(value).trim()
  if (!raw) return null
  let candidate = raw
  if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(candidate)) {
    candidate = `https://${candidate}`
  }
  try {
    const url = new URL(candidate)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null
    return url.toString()
  } catch (_) {
    return null
  }
}

export function linkifyTextOutsideAnchors (html, linkClass = 'means-link') {
  const urlPattern = /(https?:\/\/[^\s<]+)/g
  const segments = html.split(/(<a [^>]+>.*?<\/a>)/g)
  return segments.map(segment => {
    if (segment.startsWith('<a ')) return segment
    return segment.replace(urlPattern, (rawUrl) => {
      const safeUrl = normalizeLinkUrl(rawUrl)
      if (!safeUrl) return rawUrl
      const escapedHref = escapeHtml(safeUrl)
      return `<a href="${escapedHref}" target="_blank" rel="noopener noreferrer" class="${linkClass}">${rawUrl}</a>`
    })
  }).join('')
}

export function formatMeansText (value, linkClass = 'means-link') {
  if (!value) return '-'
  const escaped = escapeHtml(value)
  const markdownLinkPattern = /\[([^\]]+)\]\(([^)\s]+)\)/g
  const withMarkdownLinks = escaped.replace(markdownLinkPattern, (full, label, url) => {
    const safeUrl = normalizeLinkUrl(url)
    if (!safeUrl) return full
    const escapedHref = escapeHtml(safeUrl)
    return `<a href="${escapedHref}" target="_blank" rel="noopener noreferrer" class="${linkClass}">${label}</a>`
  })

  const formattedHtml = linkifyTextOutsideAnchors(withMarkdownLinks, linkClass)

  return DOMPurify.sanitize(formattedHtml, {
    ALLOWED_TAGS: ['a', 'span', 'br', 'strong', 'em', 'b', 'i'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
  })
}
